// ChatBot.jsx
import React from "react";

export default function ChatBot() {}